import React, { useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../../../common/Header";
import FooterInnerPagee from "../../../../common/FooterInnerPagee";
import image1 from "../../../../assets/people/peoplebannerimg.png";
import img1 from "../../../../assets/people/img1.jpeg";
import img2 from "../../../../assets/people/img2.jpeg";
import img3 from "../../../../assets/people/img3.jpg";
import img4 from "../../../../assets/people/img4.jpeg";
import img5 from "../../../../assets/people/img5.jpeg";
import img6 from "../../../../assets/people/img6.jpeg";
import img7 from "../../../../assets/people/img7.jpeg";
import img8 from "../../../../assets/people/img8.jpeg";
import img9 from "../../../../assets/people/img9.jpeg";
import img10 from "../../../../assets/people/img10.jpeg";
import img11 from "../../../../assets/people/img11.png";
import img12 from "../../../../assets/people/img12.jpeg";
import img13 from "../../../../assets/MohammedNisham.jpeg";
import LeftSideNavigation from "../../../../common/LeftSideNavigation";

const Administrative = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const teamCategories = [
    {
      title: "Administrative",
      members: [
        {
          src: img4,
          name: "Nousheetha AC",
          position: "Assistant Executive (Accounts)",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Manages account and administrative tasks."
        }
      ]
    },
  ];

  return (
    <>
      <Grid container>
        <Header />
        {/* Full-width Hero Image */}
        <Grid
          item
          xs={12}
          sx={{
            height: { xs: "60vh", md: "70vh" },
            backgroundImage: `url(${image1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Main Content Area - Below Hero Image */}
        <Grid container sx={{ bgcolor: "#f5f5f5", color: "#fff" }}>
          {/* For desktop - Left Side Navigation appears first (left side) */}
          <Grid
            item
            md={3}
            sx={{
              p: 3,
              display: { xs: 'none', md: 'block' },
              mt: 11
            }}
          >
            <LeftSideNavigation />
          </Grid>

          {/* Right Side Content - Takes full width on mobile, 75% on desktop */}
          <Grid item xs={12} md={3} sx={{ 
            p: 3,
            boxShadow: { md: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
            borderRadius: '8px',
            margin: { md: '24px 24px 24px 0' },
            backgroundColor: '#fff',
          }}>
            {teamCategories.map((category, catIndex) => (
              <Grid
                key={catIndex}
                item
                xs={12}
                sx={{
                  px: 3,
                  py: 4,
                  justifyContent: 'center',
                  borderBottom: catIndex !== teamCategories.length - 1 ? "1px solid #eee" : "none",
                }}
              >
                <Typography
                  variant="h5"
                  align="center"
                  gutterBottom
                  sx={{ 
                    fontWeight: "bold", 
                    mb: 3, 
                    fontFamily: "Montserrat, sans-serif", 
                    color: '#000',
                    textAlign: { xs: "center", md: 'left' },
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                >
                  {category.title}
                </Typography>
                <Grid container spacing={3} justifyContent={{ xs: "center", md: "flex-start" }}>
                  {category.members.map((member, memIndex) => {
                    const globalIndex = `${catIndex}-${memIndex}`;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={12}
                        key={member.name}
                        sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}
                      >
                        <Box
                          sx={{
                            width: 250,
                            height: "100%",
                            borderRadius: 3,
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            '&:hover': {
                              transform: 'translateY(-5px)',
                              boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)'
                            }
                          }}
                          onClick={() => navigate(`/profile/${globalIndex}`, { state: { member } })}
                        >
                          <Box sx={{ 
                            height: 360, 
                            overflow: "hidden", 
                            flexShrink: 0,
                            '& img': {
                              transition: 'transform 0.5s ease',
                            },
                            '&:hover img': {
                              transform: 'scale(1.05)'
                            }
                          }}>
                            <img
                              src={member.src}
                              alt={member.name}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          </Box>
                          <Box sx={{ 
                            p: 2,
                            backgroundColor: '#fff',
                          }}>
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              color="#000"
                              sx={{ 
                                fontFamily: "Montserrat, sans-serif",
                                mb: 1
                              }}
                            >
                              {member.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ 
                                fontFamily: "Montserrat, sans-serif", 
                                letterSpacing: 0,
                                fontSize: '0.875rem'
                              }}
                            >
                              {member.position}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            ))}
          </Grid>

          {/* For mobile - Left Side Navigation appears after main content */}
          <Grid
            item
            xs={12}
            sx={{
              p: 3,
              display: { xs: 'block', md: 'none' }
            }}
          >
            <LeftSideNavigation />
          </Grid>
        </Grid>
      </Grid>
      <FooterInnerPagee />
    </>
  );
};

export default Administrative;